
import axiosService from "@services/axiosService";
import { IUserCredentials, IAuthToken, Profile } from "@models/auth";
import { IAuthService } from "@services/interface/IAuthService";
import { IDataResponse } from "@services/interface/IDataResponse";
import { BaseViewModel } from "@/modelviews/BaseViewModel";
import "reflect-metadata";
import { inject, injectable } from "inversify";
import { TYPES } from "@di/types";
import { IDepartmentEmployee } from "@/models/setting/Department";
import { normalizeDepartmentEmployee } from "@services/nomalizeModel/normalizeDepartmentEmployee";


@injectable()
export class StatisticClinicRepository {


  constructor(
    @inject(TYPES.StatisticClinicService)
    private clinicService: any
  ) {}

  async fetchAll( params :any): Promise<IDataResponse<any>> {
    return await this.clinicService.fetchAll(params);
  }

  async fetchOne( id: any, params :any): Promise<IDataResponse<any>> {
    return await this.clinicService.fetchOne(id, params);
  }

  async fetchStaffs( params :any): Promise<IDataResponse<any>> {
    return await this.clinicService.fetchStaffs(params);
  }

}